import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_radio = _resolveComponent("b-form-radio");
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group");
  return _openBlock(), _createBlock(_component_b_form_radio_group, {
    class: "radio-group",
    buttons: "",
    modelValue: $options.selected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.selected = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, option => {
      return _openBlock(), _createBlock(_component_b_form_radio, {
        key: option[$props.valueField],
        value: option[$props.valueField],
        disabled: option.disabled,
        class: _normalizeClass(option.class)
      }, {
        default: _withCtx(() => [option.html ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: option.html
        }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(option.text), 1)], 64))]),
        _: 2
      }, 1032, ["value", "disabled", "class"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]);
}